import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeUnderscores' })
export class GreocRemoveUnderscoresPipe implements PipeTransform {
  transform(value?: string) {
    if (typeof value !== 'string') return value;
    return value.replace('_', ' ');
  }
}
